import React from 'react';
import PropTypes from 'prop-types';
import Table, {TableBody, TableCell, TableHead, TableRow} from 'material-ui/Table';
import {withStyles} from 'material-ui/styles';
import PercentileDot from "./PercentileDot";

const styles = theme => ({
  table: {
    marginBottom: 12,
    overflow: 'visible'
  },
  tableRow: {
    height: 20,
  },
  tableCell: {
    padding: '0 8px',
    overflow: 'visible'
  }
});

const safeValue = (parent, prop) => {
  if (parent && parent[prop]) {
    return parent[prop];
  }
  return '';
};

const StatsTable = ({stats, height, classes}) => {

  return (
    <Table className={classes.table} style={{height: height - 12}}>
      <TableHead>
        <TableRow className={classes.tableRow}>
          <TableCell className={classes.tableCell}>2016 Stat</TableCell>
          <TableCell className={classes.tableCell} numeric>Value</TableCell>
          <TableCell className={classes.tableCell} numeric>League</TableCell>
          <TableCell className={classes.tableCell} numeric>Rank</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow className={classes.tableRow}>
          <TableCell className={classes.tableCell}>
            <PercentileDot stats={stats} property="shots" label="Shots"/>
          </TableCell>
          <TableCell className={classes.tableCell} numeric>{stats.shots}</TableCell>
          <TableCell className={classes.tableCell} numeric>{safeValue(stats.league, 'shots')}</TableCell>
          <TableCell className={classes.tableCell} numeric>{safeValue(stats.rank, 'shots')}</TableCell>
        </TableRow>
        <TableRow className={classes.tableRow}>
          <TableCell className={classes.tableCell}>
            <PercentileDot stats={stats} property="goals" label="Goals"/>
          </TableCell>
          <TableCell className={classes.tableCell} numeric>{stats.goals}</TableCell>
          <TableCell className={classes.tableCell} numeric>{safeValue(stats.league, 'goals')}</TableCell>
          <TableCell className={classes.tableCell} numeric>{safeValue(stats.rank, 'goals')}</TableCell>
        </TableRow>
        <TableRow className={classes.tableRow}>
          <TableCell className={classes.tableCell}>
            <PercentileDot stats={stats} property="assists" label="Assists"/>
          </TableCell>
          <TableCell className={classes.tableCell} numeric>{stats.assists}</TableCell>
          <TableCell className={classes.tableCell} numeric>{safeValue(stats.league, 'assists')}</TableCell>
          <TableCell className={classes.tableCell} numeric>{safeValue(stats.rank, 'assists')}</TableCell>
        </TableRow>
        <TableRow className={classes.tableRow}>
          <TableCell className={classes.tableCell}>
            <PercentileDot stats={stats} property="points" label="Points"/>
          </TableCell>
          <TableCell className={classes.tableCell} numeric>{stats.points}</TableCell>
          <TableCell className={classes.tableCell} numeric>{safeValue(stats.league, 'points')}</TableCell>
          <TableCell className={classes.tableCell} numeric>{safeValue(stats.rank, 'points')}</TableCell>
        </TableRow>
        <TableRow className={classes.tableRow}>
          <TableCell className={classes.tableCell}>
            <PercentileDot stats={stats} property="shootingPct" label="Shooting %"/>
          </TableCell>
          <TableCell className={classes.tableCell} numeric>{stats.shootingPct}</TableCell>
          <TableCell className={classes.tableCell} numeric>{safeValue(stats.league, 'shootingPct')}</TableCell>
          <TableCell className={classes.tableCell} numeric>{safeValue(stats.rank, 'shootingPct')}</TableCell>
        </TableRow>
        <TableRow className={classes.tableRow}>
          <TableCell className={classes.tableCell}>
            <PercentileDot stats={stats} property="hits" label="Hits"/>
          </TableCell>
          <TableCell className={classes.tableCell} numeric>{stats.hits}</TableCell>
          <TableCell className={classes.tableCell} numeric>{safeValue(stats.league, 'hits')}</TableCell>
          <TableCell className={classes.tableCell} numeric>{safeValue(stats.rank, 'hits')}</TableCell>
        </TableRow>
        <TableRow className={classes.tableRow}>
          <TableCell className={classes.tableCell}>
            <PercentileDot stats={stats} property="fights" label="Fights"/>
          </TableCell>
          <TableCell className={classes.tableCell} numeric>{stats.fights}</TableCell>
          <TableCell className={classes.tableCell} numeric>{safeValue(stats.league, 'fights')}</TableCell>
          <TableCell className={classes.tableCell} numeric>{safeValue(stats.rank, 'fights')}</TableCell>
        </TableRow>
        <TableRow className={classes.tableRow}>
          <TableCell className={classes.tableCell}>
            <PercentileDot stats={stats} property="penalties" label="Penalties"/>
          </TableCell>
          <TableCell className={classes.tableCell} numeric>{stats.penalties}</TableCell>
          <TableCell className={classes.tableCell} numeric>{safeValue(stats.league, 'penalties')}</TableCell>
          <TableCell className={classes.tableCell} numeric>{safeValue(stats.rank, 'penalties')}</TableCell>
        </TableRow>
        <TableRow className={classes.tableRow}>
          <TableCell className={classes.tableCell}>
            <PercentileDot stats={stats} property="plusMinus" label="Plus/Minus"/>
          </TableCell>
          <TableCell className={classes.tableCell} numeric>{stats.plusMinus}</TableCell>
          <TableCell className={classes.tableCell} numeric>{safeValue(stats.league, 'plusMinus')}</TableCell>
          <TableCell className={classes.tableCell} numeric>{safeValue(stats.rank, 'plusMinus')}</TableCell>
        </TableRow>
      </TableBody>
    </Table>
  )
};

StatsTable.propTypes = {
  stats: PropTypes.object.isRequired
};

export default withStyles(styles)(StatsTable)


// WEBPACK FOOTER //
// ./src/components/StatsTable.js